import { FormikProps } from 'formik';
import MCheckboxGroup from '@Components/Base/Filter/components/CheckboxGroup';

interface MultiSelectProps<T> {
  formik: FormikProps<T>;
  options: string[];
  formikKey: string;
  showSearch?: boolean;
}

const MultiSelect = <T,>({
  formik,
  options,
  formikKey,
  showSearch = false,
}: MultiSelectProps<T>): JSX.Element => {
  const value = formik.getFieldMeta(formikKey).value as string[];

  return (
    <MCheckboxGroup<T>
      formik={formik}
      formikValue={value}
      formikValueName={formikKey}
      itemTypes={options}
      showSearch={showSearch}
    />
  );
};

export default MultiSelect;
